<template>
  <form>
    <div>
      <v-container fluid grid-list-sm>
        <v-layout row wrap>
          <v-flex lg4 md4 xs12>
            <v-radio-group v-model="generalForm.dRi" row :mandatory="true" class="ml-3 pa-0" @input="doBranchDRI()" :disabled="disableField">
              <v-radio :label="labels.direct" value="true"></v-radio>
              <v-radio :label="labels.reinsurance" value="false"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex lg8 md8 xs12>
            <v-switch v-model="generalForm.appCoins" :label="labels.appCoins" :disabled="disableField"></v-switch>
          </v-flex>
          <v-flex xs12 v-if="policyGeneralParam.showPolNo">
            <v-layout row wrap>
              <v-flex lg4 md4 xs12>
                <v-text-field
                  v-model="generalForm.polNo"
                  :label="labels.polNo"
                  :error-messages="errors.collect('polNo')"
                  data-vv-name="polNo"
                  :data-vv-as="labels.polNo"
                  v-validate="'required|max:16'"
                  :disabled="disableField"
                ></v-text-field>
              </v-flex>
              <v-flex lg4 md4 xs12>
                <v-text-field
                  v-model="generalForm.cnNo_Date"
                  :label="labels.cnNo_Date"
                  :error-messages="errors.collect('cnNo_Date')"
                  data-vv-name="cnNo_Date"
                  :data-vv-as="labels.cnNo_Date"
                  :disabled="disableField"
                ></v-text-field>
              </v-flex>
              <v-flex lg4 md4 xs12> </v-flex>
            </v-layout>
          </v-flex>
          <v-flex lg4 md4 xs12>
            <v-autocomplete
              :items="policyGeneralParam.branchList"
              v-model="generalForm.branch"
              :label="labels.branch"
              item-text="label"
              item-value="value"
              data-vv-name="branch"
              :data-vv-as="labels.branch"
              :error-messages="errors.collect('branch')"
              v-validate="'required'"
              @input="doBranchDRI"
              :disabled="disableField"
              :loading="generalLoading"
            ></v-autocomplete>
          </v-flex>
          <v-flex lg4 md4 xs12>
            <v-autocomplete
              :items="policyGeneralParam.polTypeList"
              v-model="generalForm.polType"
              :label="labels.polType"
              item-text="label"
              item-value="value"
              data-vv-name="polType"
              :data-vv-as="labels.polType"
              :error-messages="errors.collect('polType')"
              v-validate="'required'"
              @input="doPolType"
              :disabled="disableField"
              :loading="generalLoading"
            ></v-autocomplete>
          </v-flex>
          <v-flex lg4 md4 xs12>
            <v-autocomplete
              :items="policyGeneralParam.busSrcList"
              v-model="generalForm.busSrc"
              :label="labels.busSrc"
              item-text="label"
              item-value="value"
              data-vv-name="busSrc"
              :data-vv-as="labels.busSrc"
              :error-messages="errors.collect('busSrc')"
              v-validate="'required'"
              :disabled="disableField"
              :loading="generalLoading"
            ></v-autocomplete>
          </v-flex>
          <v-flex lg4 md4 xs12>
            <v-autocomplete
              :items="policyGeneralParam.billTypeList"
              v-model="generalForm.billType"
              :label="labels.billType"
              item-text="label"
              item-value="value"
              data-vv-name="billType"
              :data-vv-as="labels.billType"
              :error-messages="errors.collect('billType')"
              v-validate="'required'"
              :loading="generalLoading"
              :disabled="!polType.perBancBill"
              @input="getDefExpDate"
            ></v-autocomplete>
          </v-flex>
          <v-flex lg4 md4 xs12>
            <cal-picker
              v-model="generalForm.comDate"
              :label="labels.comDate"
              v-validate="comDateValidation"
              :data-vv-as="labels.comDate"
              data-vv-name="comDate"
              :error-messages="errors.collect('comDate')"
              @input="doComDate"
              :loading="dateLoading"
            ></cal-picker>
            <warning v-model="warnComDate" @ok="doAcceptComDate" @cancel="doCancelComDate">{{ warnComDateMsg }}</warning>
          </v-flex>
          <v-flex lg4 md4 xs12>
            <cal-picker
              v-model="generalForm.expDate"
              :label="labels.expDate"
              v-validate="expDateValidation"
              :data-vv-as="labels.expDate"
              data-vv-name="expDate"
              :error-messages="errors.collect('expDate')"
              :hint="daysCoverage"
              :loading="dateLoading"
              :disabled="polType.perBancBill"
              @input="doExpDate"
            ></cal-picker>
            <warning v-model="warnExpDate" @ok="doAcceptExpDate">{{ warnExpDateMsg }}</warning>
          </v-flex>
          <v-flex lg4 md4 xs12 v-if="polType.comDateOpt === 'O'">
            <v-text-field
              v-model="generalForm.uwYr"
              :label="labels.uwYr"
              :error-messages="errors.collect('uwYr')"
              data-vv-name="uwYr"
              :data-vv-as="labels.uwYr"
              v-validate="uwYrValidation"
              v-int-mask="{ intScale: 4 }"
              type="tel"
              :loading="dateLoading"
              @input="doUwYr"
            ></v-text-field>
          </v-flex>
          <v-flex lg4 md4 xs12 v-else>
            <v-text-field
              v-model="generalForm.uwYr"
              :label="labels.uwYr"
              :error-messages="errors.collect('uwYr')"
              data-vv-name="uwYr"
              :data-vv-as="labels.uwYr"
              v-validate="'required|max:4'"
              disabled
              :loading="dateLoading"
            ></v-text-field>
          </v-flex>
          <v-flex lg4 md4 xs12>
            <cal-picker
              v-model="generalForm.tranDate"
              :label="labels.tranDate"
              v-validate="tranDateValidation"
              :data-vv-as="labels.tranDate"
              data-vv-name="tranDate"
              :error-messages="errors.collect('tranDate')"
              :loading="dateLoading"
              @input="doTranDate"
            ></cal-picker>
          </v-flex>
          <v-flex lg4 md4 xs12 v-if="policyGeneralParam.showEndtDate">
            <cal-picker
              v-model="generalForm.endtDate"
              :label="labels.endtDate"
              v-validate="valEndtDate"
              :data-vv-as="labels.endtDate"
              data-vv-name="endtDate"
              :error-messages="errors.collect('endtDate')"
              @input="doEndtDate"
              :loading="endtDateLoading"
            ></cal-picker>
          </v-flex>
          <v-flex lg4 md4 xs12 v-if="!policyGeneralParam.showEndtDate"></v-flex>
          <v-flex lg4 md4 xs12>
            <cal-picker
              v-model="generalForm.firstIssDate"
              :label="labels.firstIssDate"
              v-validate="'required'"
              :data-vv-as="labels.firstIssDate"
              data-vv-name="firstIssDate"
              :error-messages="errors.collect('firstIssDate')"
              :loading="dateLoading"
              @input="doWarnFirstIssDate"
              :disabled="policyGeneralParam.showEndtDate"
            ></cal-picker>
            <warning v-model="warnFirstIssDate" @ok="doAcceptFirstIssDate" @cancel="doCancelFirstIssDate">{{ warnFirstIssDateMsg }}</warning>
          </v-flex>
          <v-flex lg4 md4 xs12>
            <cal-picker
              v-model="generalForm.acceptDate"
              :label="labels.acceptDate"
              v-validate="'required'"
              :data-vv-as="labels.acceptDate"
              data-vv-name="acceptDate"
              :error-messages="errors.collect('acceptDate')"
              :loading="dateLoading"
              @input="doWarnAcceptDate"
            ></cal-picker>
            <warning v-model="warnAcceptDate" @ok="doAcceptAcceptDate" @cancel="doCancelAcceptDate">{{ warnAcceptDateMsg }}</warning>
          </v-flex>
          <v-flex lg4 md4 xs12>
            <time-picker
              v-model="generalForm.acceptTime"
              :label="labels.acceptTime"
              v-validate="'required'"
              :data-vv-as="labels.acceptTime"
              data-vv-name="acceptTime"
              :error-messages="errors.collect('acceptTime')"
            ></time-picker>
          </v-flex>
          <!-- 2020-10-08 LYT OS-502 -->
          <v-flex lg4 md4 xs12 v-if="(polMaster.tranType === 'E' || polMaster.tranType === 'C') && polType.perBancBill">
            <v-autocomplete
              :items="policyGeneralParam.endtCodeList"
              v-model="generalForm.endtCode"
              :label="labels.endtCode"
              item-text="label"
              item-value="value"
              data-vv-name="endtCode"
              :data-vv-as="labels.endtCode"
              :error-messages="errors.collect('endtCode')"
              :loading="generalLoading"
              clearable
            ></v-autocomplete>
          </v-flex>
          <!-- 2020-10-08 LYT OS-502 -->
          <v-flex lg4 md4 xs12 v-if="polMaster.tranType === 'C' && polType.perBancBill">
            <v-autocomplete
              :items="policyGeneralParam.cancelCodeList"
              v-model="generalForm.cancelCode"
              :label="labels.cancelCode"
              item-text="label"
              item-value="value"
              data-vv-name="cancelCode"
              :data-vv-as="labels.cancelCode"
              :error-messages="errors.collect('cancelCode')"
              :loading="generalLoading"
              clearable
            ></v-autocomplete>
          </v-flex>
          <v-flex lg8 md8 xs12 v-if="polMaster.tranType === 'E'"></v-flex>
          <v-flex lg4 md4 xs12 v-if="polMaster.tranType === 'C'"></v-flex>
          <v-flex lg12 md12 xs12>
            <v-btn class="mt-2 mr-2" color="error" dark :loading="policy.saving" @click.prevent="doExit">
              {{ labels.exit }}
              <v-icon dark right>mdi-exit-to-app</v-icon>
            </v-btn>
            <v-btn class="mt-2 mr-2" color="accent" dark :loading="policy.saving" @click.prevent="doReset">
              {{ labels.reset }}
              <v-icon dark right>mdi-refresh</v-icon>
            </v-btn>
            <v-btn class="mt-2 mr-2" color="info" dark type="submit" :loading="policy.saving" @click.prevent="doSave">
              {{ labels.save }}
              <v-icon dark right>mdi-content-save</v-icon>
            </v-btn>
            <v-btn class="mt-2 mr-2" color="primary" dark :loading="policy.saving" @click.prevent="doProceed">
              {{ labels.proceed }}
              <v-icon dark right>mdi-arrow-right-bold-box</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-dialog v-model="policy.saving" persistent width="300">
          <v-card color="primary" dark>
            <v-card-text>
              Processing...
              <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-container>
    </div>
  </form>
</template>

<script>
import { toDate, parseISO } from 'date-fns'
import addYears from 'date-fns/addYears'
import subDays from 'date-fns/subDays'
import addDays from 'date-fns/addDays'
import addMonths from 'date-fns/addMonths'
import isAfter from 'date-fns/isAfter'
import differenceInDays from 'date-fns/differenceInDays'
import { formatDisplayTime, removeTime, formatDisplayDate, formatDisplayDate2 } from '@/utils/date'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { POLICY_LIFECYCLE, POLICY_GENERAL, POLICY_HEADER_TAB } from '@/store/types'
import clone from 'clone'
import { isEqual } from '@/utils/compare'

export default {
  data() {
    return {
      labels: {
        direct: 'Direct',
        reinsurance: 'Reinsurance',
        appCoins: 'Coinsurance',
        branch: 'Branch*',
        polType: 'Policy Type*',
        polNo: 'Policy No.*',
        busSrc: 'Business Source',
        cnNo: 'CN No.',
        cnDate: 'Date',
        cnNo_Date: 'CN No. / Date',
        billType: 'Billing Type',
        comDate: 'Commencement Date*',
        expDate: 'Expiry Date*',
        endtDate: 'Endorsement Date*',
        uwYr: 'Underwriting Year*',
        tranDate: 'Transaction Date*',
        firstIssDate: 'First Issue Date*',
        acceptDate: 'Acceptance Date*',
        acceptTime: 'Time*',
        exit: 'Exit',
        reset: 'Reset',
        save: 'Save',
        proceed: 'Proceed',
        endtCode: 'Endorsement Code',
        cancelCode: 'Cancellation Code'
      },
      generalForm: {
        dRi: 'true',
        appCoins: false,
        branch: undefined,
        polType: undefined,
        polNo: undefined,
        renCnt: 0,
        endtCnt: 0,
        busSrc: undefined,
        billType: undefined,
        comDate: undefined,
        expDate: undefined,
        endtDate: undefined,
        uwYr: undefined,
        tranDate: undefined,
        firstIssDate: undefined,
        acceptDate: undefined,
        acceptTime: undefined,
        tranType: undefined,
        cnNo: undefined,
        cnDate: undefined,
        cnNo_Date: undefined,
        endtCode: undefined,
        cancelCode: undefined
      },
      copyGeneralForm: {
        tranDate: undefined
      },
      polType: {
        comDateOpt: undefined,
        polNoForm: undefined,
        perBancBill: undefined,
        expiryTime: undefined
      },
      branchDRI: {
        genPolNo: undefined
      },
      policyGeneralParam: {
        showPolNo: false,
        polTypeList: [],
        showEndtDate: undefined,
        startUWYr: undefined,
        add1UwYr: undefined,
        fromDateRange: undefined,
        toDateRange: undefined,
        acctPeriod: undefined,
        endtCodeList: [],
        cancelCodeList: []
      },
      policy: {
        saving: false
      },
      disableField: undefined,
      warnComDate: false,
      acceptComDate: false,
      warnComDateMsg: undefined,
      generalLoading: false,
      dateLoading: false,
      warnExpDate: false,
      acceptExpDate: false,
      warnExpDateMsg: undefined,
      warnFirstIssDate: false,
      acceptFirstIssDate: false,
      warnFirstIssDateMsg: undefined,
      warnAcceptDate: false,
      acceptAcceptDate: false,
      warnAcceptDateMsg: undefined,
      endtDateLoading: false,
      error: {
        endtDate: undefined
      }
    }
  },
  computed: {
    proceedLoading() {
      if (this.generalLoading || this.dateLoading) {
        return true
      } else {
        return false
      }
    },
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    minComDate() {
      return new Date()
    },
    maxComDate() {
      if (this.daysBeforeCover !== undefined) {
        let result = new Date()
        result.setHours(0, 0, 0, 0)
        result = addDays(result, this.daysBeforeCover)
        return result
      }
      return undefined
    },
    comDateValidation() {
      if (this.polType.comDateOpt === 'M') {
        // return 'required|start_before_today|days_before_cover:' + this.daysBeforeCover
        return 'required'
      } else if (this.polType.comDateOpt === 'N') {
        return 'required_blank'
      } else {
        return ''
      }
    },
    expDateValidation() {
      if (this.generalForm.comDate === undefined || this.generalForm.comDate === '') {
        return 'required_blank'
      } else if (this.generalForm.comDate !== undefined && this.generalForm.comDate !== '') {
        return 'required|start_enddate:' + this.generalForm.comDate
      } else {
        return ''
      }
    },
    uwYrValidation() {
      if (this.generalForm.comDate !== undefined && this.generalForm.comDate !== '') {
        var iMonth = (this.generalForm.comDate.getMonth() + 1).toString().padStart(2, '0')
        var iDay = this.generalForm.comDate.getDate().toString().padStart(2, '0')
        var iMonthDay = iMonth + iDay
        if (parseInt(iMonthDay) >= parseInt(this.policyGeneralParam.startUWYr)) {
          if (!this.policyGeneralParam.add1UwYr) {
            return 'required|numeric|max:4|valNotEqualUWYear:' + this.generalForm.comDate.getFullYear()
          } else {
            return 'required|numeric|max:4|valEqualUWYear:' + this.generalForm.comDate.getFullYear()
          }
        } else if (parseInt(iMonthDay) < parseInt(this.policyGeneralParam.startUWYr)) {
          if (this.policyGeneralParam.add1UwYr) {
            return 'required|numeric|max:4|valNotEqualUWYear:' + this.generalForm.comDate.getFullYear()
          } else {
            return 'required|numeric|max:4|valEqualUWYear:' + this.generalForm.comDate.getFullYear()
          }
        } else {
          return 'required|numeric|max:4'
          // return 'required|numeric|max:4|valUWYear:' + new Date().getFullYear()
        }
      } else {
        return 'required|numeric|max:4'
        // return 'required|numeric|max:4|valUWYear:' + new Date().getFullYear()
      }
    },
    daysCoverage() {
      if (this.generalForm.comDate && this.generalForm.expDate) {
        if (this.generalForm.expDate === undefined || this.generalForm.comDate === undefined) {
          return undefined
        } else {
          return 'Days Covered: ' + (differenceInDays(toDate(this.generalForm.expDate), toDate(this.generalForm.comDate)) + 1)
        }
      } else {
        return undefined
      }
    },
    tranDateValidation() {
      return (
        'required|isAvailTranDateRange:' +
        this.policyGeneralParam.fromDateRange +
        ',' +
        this.policyGeneralParam.toDateRange +
        '|valTranDateRange:' +
        this.policyGeneralParam.fromDateRange +
        ',' +
        this.policyGeneralParam.toDateRange +
        '|valAcctPer:' +
        this.policyGeneralParam.acctPeriod
      )
    },
    valEndtDate() {
      if (this.error.endtDate === undefined) {
        return 'required'
      } else {
        return 'required|valField:' + this.error.endtDate
      }
    }
  },
  methods: {
    doInit() {
      // this.loading = false
      this.fetchData()
      if (this.$store.state.underwriting.policyMode === 'Endorsement' || this.$store.state.underwriting.policyMode === 'Cancellation') {
        this.policyGeneralParam.showEndtDate = true
      } else {
        this.policyGeneralParam.showEndtDate = false
      }

      if (this.polMaster.polNo) {
        this.disableField = true
        this.policyGeneralParam.showPolNo = true
        if (this.polMaster.dri) {
          this.generalForm.dRi = 'true'
        } else {
          this.generalForm.dRi = 'false'
        }
        this.generalForm.appCoins = this.polMaster.appCoIns
        this.generalForm.branch = this.polMaster.branch
        this.generalForm.polType = this.polMaster.polType
        this.generalForm.polNo = this.polMaster.polNo
        this.generalForm.renCnt = this.polMaster.renCnt
        this.generalForm.endtCnt = this.polMaster.endtCnt
        this.generalForm.busSrc = this.polMaster.busSrc
        this.generalForm.billType = this.polMaster.billType
        this.generalForm.comDate = this.polMaster.comDate === null ? undefined : this.needsParseISO(this.polMaster.comDate) ? parseISO(this.polMaster.comDate) : this.polMaster.comDate
        this.generalForm.expDate = this.polMaster.expDate === null ? undefined : this.needsParseISO(this.polMaster.expDate) ? parseISO(this.polMaster.expDate) : this.polMaster.expDate
        this.generalForm.tranDate = this.needsParseISO(this.polMaster.tranDate) ? parseISO(this.polMaster.tranDate) : this.polMaster.tranDate
        // copy
        this.copyGeneralForm.tranDate = this.generalForm.tranDate

        this.generalForm.firstIssDate = this.needsParseISO(this.polMaster.firstIssDate) ? parseISO(this.polMaster.firstIssDate) : this.polMaster.firstIssDate
        this.generalForm.acceptDate = this.needsParseISO(this.polMaster.acceptDate) ? parseISO(this.polMaster.acceptDate) : this.polMaster.acceptDate
        if (this.polMaster.tranType === 'E' || this.polMaster.tranType === 'C') {
          this.generalForm.endtDate = this.polMaster.endtDate === null ? new Date() : this.needsParseISO(this.polMaster.endtDate) ? parseISO(this.polMaster.endtDate) : this.polMaster.endtDate
        } else {
          this.generalForm.endtDate = this.polMaster.endtDate === null ? undefined : this.needsParseISO(this.polMaster.endtDate) ? parseISO(this.polMaster.endtDate) : this.polMaster.endtDate
        }
        this.generalForm.acceptTime = this.polMaster.acceptTime === '' ? formatDisplayTime(this.generalForm.acceptDate) : this.polMaster.acceptTime
        this.generalForm.uwYr = this.polMaster.uwYr
        this.generalForm.tranType = this.polMaster.tranType
        this.generalForm.cnNo = this.polMaster.cnNo
        this.generalForm.cnDate = this.polMaster.cnDate
        this.generalForm.cnNo_Date = this.polMaster.cnNo !== '' ? this.polMaster.cnNo + ' / ' + formatDisplayDate(this.polMaster.cnDate) : '-'

        this.generalForm.endtCode = this.polMaster.endtCode
        this.generalForm.cancelCode = this.polMaster.cancelCode
      } else {
        this.disableField = false
        // Default value from vuex store 1st

        if (this.$store.state.underwriting.policyMode === 'New') {
          this.generalForm.dRi = 'true'
          this.generalForm.appCoins = false

          // default branch
          this.generalForm.branch = this.$store.state.token.userBranch

          // this.doBranchDRI()
          // if (this.generalForm.polNo) {
          //   this.policyGeneralParam.showPolNo = true
          // } else {
          //   this.policyGeneralParam.showPolNo = false
          // }
          // this.generalForm.comDate = new Date()
          // if (this.generalForm.comDate) {
          //   // Add 1 year to end Date
          //   let expDate = addYears(this.generalForm.comDate, 1)
          //   expDate = subDays(expDate, 1)
          //   this.generalForm.expDate = expDate
          // }

          this.generalForm.acceptDate = removeTime(new Date())
          // Need break down acceptDate into date and time for input
          if (this.generalForm.acceptDate) {
            this.generalForm.acceptTime = formatDisplayTime(this.generalForm.acceptDate)
          }

          // this.generalForm.uwYr = this.generalForm.comDate.getFullYear()
          this.generalForm.tranDate = new Date()
          // this.generalForm.firstIssDate = this.generalForm.comDate

          this.generalForm.tranType = 'N'
        }
      }
      this.copyGeneralForm = clone(this.generalForm)
      this.doTranDate()
    },
    async fetchData() {
      const apiUrl = this.$store.state.underwriting.menu.policyGeneral
      if (apiUrl) {
        try {
          this.generalLoading = true
          const result = await this.$http.get(apiUrl)
          if (result.data.polTypeList) {
            this.$set(this.policyGeneralParam, 'polTypeList', result.data.polTypeList)
          }
          if (result.data.branchList) {
            this.$set(this.policyGeneralParam, 'branchList', result.data.branchList)
          }
          if (result.data.busSrcList) {
            this.$set(this.policyGeneralParam, 'busSrcList', result.data.busSrcList)
          }
          if (result.data.billTypeList) {
            this.$set(this.policyGeneralParam, 'billTypeList', result.data.billTypeList)
          }
          // 2020-07-08 LYT OS-257
          if (result.data.endtCodeList) {
            this.$set(this.policyGeneralParam, 'endtCodeList', result.data.endtCodeList)
          }
          if (result.data.cancelCodeList) {
            this.$set(this.policyGeneralParam, 'cancelCodeList', result.data.cancelCodeList)
          }
          this.policyGeneralParam.startUWYr = result.data.startUWYr
          this.policyGeneralParam.add1UwYr = result.data.add1UwYr
          this.policyGeneralParam.fromDateRange = result.data.fromDateRange
          this.policyGeneralParam.toDateRange = result.data.toDateRange

          if (this.$store.state.underwriting.policyMode === 'New') {
            // Default first record from ‘Policy Type Parameters’
            if (this.policyGeneralParam.polTypeList && this.generalForm.polType === undefined) {
              this.generalForm.polType = this.policyGeneralParam.polTypeList[0].value
              this.getPolType()
            }
            // If there is only 1 branch in the list, assign it
            if (this.policyGeneralParam.branchList) {
              //   this.generalForm.branch = this.policyGeneralParam.branchList[0].value
              this.doBranchDRI()
            }
            // 2020-01-07 LYT OS-629
            // Default first record from ‘Policy Type Parameters’
            // if (this.policyGeneralParam.busSrcList && this.generalForm.busSrc === undefined) {
            //   this.generalForm.busSrc = this.policyGeneralParam.busSrcList[0].value
            // }
            // Default first record from ‘Policy Type Parameters’
            if (this.policyGeneralParam.billTypeList && this.generalForm.billType === undefined) {
              this.generalForm.billType = this.policyGeneralParam.billTypeList[0].value
            }
          }

          if (this.polType.expiryTime === undefined) {
            this.setPolType()
          }

          this.generalLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.generalLoading = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    needsParseISO(value) {
      // Check if it's a string
      if (typeof value !== 'string') return false

      // Regular expression for ISO 8601 format (basic check)
      const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/

      // Verify the format
      if (!isoRegex.test(value)) return false

      // Verify if it results in a valid date
      const date = new Date(value)
      return !isNaN(date.getTime())
    },
    doComDate() {
      this.doWarnComDate()
      this.getDefUWYR()
      this.getDefExpDate()
      if (this.generalForm.comDate !== undefined && this.generalForm.comDate !== '') {
        this.generalForm.firstIssDate = this.generalForm.comDate
      } else {
        this.generalForm.firstIssDate = new Date()
      }
    },
    doExpDate() {
      this.doWarnExpDate()
    },
    doBranchDRI() {
      if (this.generalForm.branch) {
        this.getBranchDRI()
      }
    },
    async getBranchDRI() {
      const apiUrl = this.$store.state.underwriting.policyGeneralSettings.menu.branchDRI
      if (apiUrl) {
        try {
          const expand = {
            dri: this.generalForm.dRi,
            branch: this.generalForm.branch
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data) {
            const { data } = result
            this.branchDRI.genPolNo = data.genPolNo
            this.doShowPolNo()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doPolType() {
      if (this.generalForm.polType) {
        this.resetMessages() // 2020-10-27 LYT OS-526
        this.getPolType()
      }
    },
    async getPolType() {
      const apiUrl = this.$store.state.underwriting.policyGeneralSettings.menu.polType
      if (apiUrl) {
        try {
          this.dateLoading = true
          const expand = {
            polType: this.generalForm.polType
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data) {
            const { data } = result

            this.polType.expiryTime = data.expiryTime
            this.polType.comDateOpt = data.comDateOpt
            if (data.comDateOpt === 'M') {
              // this.polType.comDateOpt = true
              this.generalForm.comDate = new Date()
              // this.generalForm.uwYr = this.generalForm.comDate.getFullYear()
              // this.generalForm.firstIssDate = this.generalForm.comDate
              // this.generalForm.tranDate = new Date()
            } else {
              this.generalForm.comDate = undefined
              this.generalForm.expDate = undefined
              // this.polType.comDateOpt = false
            }
            this.doComDate()
            // this.getDefUWYR()
            this.polType.polNoForm = data.polNoForm
            this.polType.perBancBill = data.perBancBill

            // 2020-10-22 LYT OS-526
            if (this.polType.perBancBill === false) {
              this.generalForm.billType = ''
            } else {
              if (this.$store.state.underwriting.policyMode === 'New') {
                this.generalForm.billType = ''
              }
            }

            this.doShowPolNo()
            this.dateLoading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.dateLoading = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async setPolType() {
      const apiUrl = this.$store.state.underwriting.policyGeneralSettings.menu.polType
      if (apiUrl) {
        try {
          const expand = {
            polType: this.generalForm.polType
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data) {
            const { data } = result
            this.polType.expiryTime = data.expiryTime
            this.polType.comDateOpt = data.comDateOpt
            this.polType.polNoForm = data.polNoForm
            this.polType.perBancBill = data.perBancBill
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doShowPolNo() {
      if (this.branchDRI.genPolNo === false || this.polMaster.polNo !== undefined) {
        this.policyGeneralParam.showPolNo = true
      } else if (this.branchDRI.genPolNo === true && this.polType.polNoForm === 0 && this.polMaster.polNo !== undefined) {
        this.policyGeneralParam.showPolNo = true
      } else {
        this.policyGeneralParam.showPolNo = false
      }
    },
    doUwYr() {
      if (this.generalForm.comDate === undefined || this.generalForm.comDate === '') {
        if (parseInt(this.generalForm.uwYr) !== parseInt(new Date().getFullYear())) {
          this.$toast.warning('10016 – This is more than 1 year earlier/later than current year. (10016)')
        }
        // this.generalForm.uwYr = this.generalForm.uwYr.getFullYear()
      }
    },
    getDefUWYR() {
      if (this.generalForm.comDate === undefined || this.generalForm.comDate === '') {
        this.generalForm.uwYr = new Date().getFullYear()
      } else {
        // this.policyGeneralParam.startUWYr
        var iMonth = (this.generalForm.comDate.getMonth() + 1).toString().padStart(2, '0')
        var iDay = this.generalForm.comDate.getDate().toString().padStart(2, '0')
        var iMonthDay = iMonth + iDay

        var iAdd1UwYr = 0
        if (this.policyGeneralParam.add1UwYr) {
          iAdd1UwYr = 1
        }
        if (parseInt(iMonthDay) >= parseInt(this.policyGeneralParam.startUWYr)) {
          this.generalForm.uwYr = this.generalForm.comDate.getFullYear() + iAdd1UwYr
        } else {
          this.generalForm.uwYr = this.generalForm.comDate.getFullYear() - 1 + iAdd1UwYr
        }
      }
    },
    getDefExpDate() {
      if (this.generalForm.comDate) {
        // 2020-11-26 LYT SR5661
        if (
          this.generalForm.billType === 'A' ||
          this.generalForm.billType === '' ||
          this.generalForm.billType === null ||
          this.generalForm.billType === undefined
        ) {
          let comDateYear = this.generalForm.comDate.getFullYear()
          if (this.generalForm.comDate.getMonth() === 1 && this.generalForm.comDate.getDate() === 29) {
            this.generalForm.expDate = new Date(comDateYear + 1, 1, 28)
          } else {
            // Add 1 year to end Date
            let expDate = addYears(this.generalForm.comDate, 1)
            if (this.polType.expiryTime === 2400) {
              expDate = subDays(expDate, 1)
            }
            this.generalForm.expDate = expDate
          }
        } else if (this.generalForm.billType === 'M') {
          let expDate = addMonths(this.generalForm.comDate, 1)
          if (this.polType.expiryTime === 2400) {
            expDate = subDays(expDate, 1)
          }
          this.generalForm.expDate = expDate
        } else if (this.generalForm.billType === 'T') {
          let expDate = addMonths(this.generalForm.comDate, 4)
          if (this.polType.expiryTime === 2400) {
            expDate = subDays(expDate, 1)
          }
          this.generalForm.expDate = expDate
        } else if (this.generalForm.billType === 'Q') {
          let expDate = addMonths(this.generalForm.comDate, 3)
          if (this.polType.expiryTime === 2400) {
            expDate = subDays(expDate, 1)
          }
          this.generalForm.expDate = expDate
        }
      }
    },
    doProceed() {
      this.resetMessages()
      this.doValidateAllWarn().then((result2) => {
        if (result2) {
          this.$validator.validateAll().then((result) => {
            if (result) {
              this.policy.saving = true
              // this.$store.dispatch('savePolicyGeneral', this.generalForm).then(() => {
              this.doPolMasterSave().then((success) => {
                if (success) {
                  this.$store.commit(POLICY_LIFECYCLE, 2)
                  this.$store.commit(POLICY_HEADER_TAB, 0)
                  this.$router.push({ name: 'policyHeader' })
                } else {
                  this.$toast.error('There was an error saving policy record. ' + this.$store.state.underwriting.policy.saveError.messages)
                }
                this.policy.saving = false
              })
            } else {
              this.promptFieldCheck()
            }
          })
        }
      })
    },
    doSave() {
      this.resetMessages()
      this.doValidateAllWarn().then((result2) => {
        if (result2) {
          this.$validator.validateAll().then((result) => {
            if (result) {
              this.policy.saving = true
              // this.$store.dispatch('savePolicyGeneral', this.generalForm)
              this.doPolMasterSave().then((success) => {
                if (success) {
                  this.disableField = true
                  this.$toast.success('Policy record successfully saved.')
                } else {
                  this.$toast.error('There was an error saving policy record. ' + this.$store.state.underwriting.policy.saveError.messages)
                }
                this.policy.saving = false
              })
            } else {
              this.promptFieldCheck()
            }
          })
        }
      })
    },
    async doPolMasterSave() {
      try {
        if (isEqual(this.generalForm, this.copyGeneralForm) === true) {
          const apiUrl = this.$store.state.underwriting.policyGeneralSettings.menu.doUpdateExecIC
          if (apiUrl) {
            try {
              this.endtDateLoading = true
              const expand = {
                polNo: this.polMaster.polNo,
                renCnt: this.polMaster.renCnt,
                endtCnt: this.polMaster.endtCnt,
                acctNo1: this.polMaster.acctNo1,
                execIC: this.polMaster.execIC
              }
              const result = await this.$http.post(expandURI(apiUrl, expand))
              if (result) {
                this.endtDateLoading = false
                return true
              }
            } catch (err) {
              const { data } = err.response
              if (data) {
                this.message(data)
              }
              this.endtDateLoading = false
              return false
            }
          } else {
            this.endtDateLoading = false
            this.$toast.error('The request failed because it is trying to execute an invalid API url.')
          }
          return true
        } else {
          this.$store.commit(POLICY_GENERAL, this.generalForm)
          const saveResult = await this.$store.dispatch('savePolMasterGeneral')
          if (saveResult) {
            this.generalForm.polNo = this.polMaster.polNo
            this.policyGeneralParam.showPolNo = true
            this.copyGeneralForm = clone(this.generalForm)
            this.updateRIOutMasterTranDate()
            return true
          } else {
            return false
          }
        }
      } catch (err) {
        const { data } = err.response
        if (data) {
          this.notify(data)
        }
      }
    },
    async updateRIOutMasterTranDate() {
      if ((this.$store.state.underwriting.policyMode === 'Review' || this.$store.state.underwriting.policyMode === 'Endorsement' || this.$store.state.underwriting.policyMode === 'Cancellation') && this.generalForm.tranDate !== this.copyGeneralForm.tranDate) {
        try {
          this.$store.commit(POLICY_GENERAL, this.generalForm)
          const saveResult = await this.$store.dispatch('updateRIOutMasterTranDate')
          if (saveResult) {
            return true
          } else {
            return false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      }
    },
    doExit() {
      this.$router.push({ name: 'policyListing' }).catch(() => {})
    },
    doReset() {
      this.generalForm.dRi = 'true'
      this.generalForm.appCoins = false
      this.generalForm.branch = undefined
      this.generalForm.polType = undefined
      this.generalForm.polNo = undefined
      this.generalForm.busSrc = undefined
      this.generalForm.billType = undefined
      this.generalForm.comDate = undefined
      this.generalForm.expDate = undefined
      this.generalForm.endtDate = undefined
      this.generalForm.uwYr = undefined
      this.generalForm.tranDate = undefined
      this.generalForm.firstIssDate = undefined
      this.generalForm.acceptDate = undefined
      this.generalForm.acceptTime = undefined
      this.generalForm.endtCode = undefined
      this.generalForm.cancelCode = undefined
      this.doInit()
      this.$toast.success('The policy general form has been reset.')
    },
    async doTranDate() {
      const apiUrl = this.$store.state.underwriting.policyGeneralSettings.menu.valAcctPer
      if (apiUrl) {
        try {
          const expand = {
            tranDate: this.generalForm.tranDate
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))

          if (result.data) {
            const { data } = result
            this.policyGeneralParam.acctPeriod = data.data
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doWarnComDate() {
      if (!this.acceptComDate) {
        var nodays = differenceInDays(toDate(new Date()), toDate(this.generalForm.comDate)) + 1
        if (nodays < -60) {
          this.warnComDateMsg = '10005 – This is more than 60 days later than Today. (10005)'
          this.warnComDate = true
          return false
        } else if (nodays > 60) {
          this.warnComDateMsg = '10004 – This is more than 60 days earlier than Today. (10004)'
          this.warnComDate = true
          return false
        }
      }
      return true
    },
    doAcceptComDate() {
      this.acceptComDate = true
    },
    doCancelComDate() {
      this.generalForm.comDate = undefined
      this.doComDate()
    },
    doWarnExpDate() {
      if (
        !this.acceptExpDate &&
        (this.generalForm.expDate === undefined || this.generalForm.expDate === '') &&
        this.generalForm.comDate !== undefined &&
        this.generalForm.comDate !== ''
      ) {
        this.warnExpDateMsg = '10006 – Expiry Date cannot be blank when Commencement Date entered. (10006)'
        this.warnExpDate = true
        return false
      }
      return true
    },
    doAcceptExpDate() {
      this.acceptExpDate = true
    },
    doWarnFirstIssDate() {
      if (
        !this.acceptFirstIssDate &&
        this.generalForm.comDate !== undefined &&
        this.generalForm.comDate !== '' &&
        isAfter(removeTime(this.generalForm.comDate), removeTime(this.generalForm.firstIssDate))
      ) {
        this.warnFirstIssDateMsg = '10018 – This is earlier than Policy Commencement Date. (10018)'
        this.warnFirstIssDate = true
        return false
      }
      return true
    },
    doAcceptFirstIssDate() {
      this.acceptFirstIssDate = true
    },
    doCancelFirstIssDate() {
      this.generalForm.firstIssDate = undefined
    },
    doWarnAcceptDate() {
      if (
        !this.acceptAcceptDate &&
        this.generalForm.acceptDate !== undefined &&
        this.generalForm.acceptDate !== '' &&
        this.generalForm.comDate !== undefined &&
        this.generalForm.comDate !== ''
      ) {
        if (isAfter(removeTime(this.generalForm.acceptDate), removeTime(this.generalForm.comDate))) {
          var nodays = differenceInDays(toDate(this.generalForm.acceptDate), toDate(this.generalForm.comDate)) + 1
          this.warnAcceptDateMsg = '10009 – Acceptance Date is ' + nodays + ' days after Commencement Date. (10009)'
          this.warnAcceptDate = true
          return false
        } else {
          nodays = differenceInDays(toDate(this.generalForm.comDate), toDate(this.generalForm.acceptDate)) + 1
          if (nodays > 90) {
            this.warnAcceptDateMsg = '10010 – Acceptance Date is ' + nodays + ' days days before Commencement Date. (10010)'
            this.warnAcceptDate = true
            return false
          }
        }
      }
      return true
    },
    doAcceptAcceptDate() {
      this.acceptAcceptDate = true
    },
    doCancelAcceptDate() {
      this.generalForm.acceptDate = undefined
    },
    async doValidateAllWarn() {
      if (!this.acceptComDate) {
        if (!this.doWarnComDate()) {
          return false
        }
      }
      if (!this.acceptExpDate) {
        if (!this.doWarnExpDate()) {
          return false
        }
      }
      if (!this.acceptFirstIssDate) {
        if (!this.doWarnFirstIssDate()) {
          return false
        }
      }
      if (!this.acceptAcceptDate) {
        if (!this.doWarnAcceptDate()) {
          return false
        }
      }
      return true
    },
    async doEndtDate() {
      if (this.generalForm.endtDate !== undefined) {
        const apiUrl = this.$store.state.underwriting.policyGeneralSettings.menu.valEndtDate
        if (apiUrl) {
          this.endtDateLoading = true
          try {
            const expand = {
              endtDate: formatDisplayDate2(this.generalForm.endtDate) === '' ? null : formatDisplayDate2(this.generalForm.endtDate),
              comDate: formatDisplayDate2(this.generalForm.comDate) === '' ? null : formatDisplayDate2(this.generalForm.comDate),
              expDate: formatDisplayDate2(this.generalForm.expDate) === '' ? null : formatDisplayDate2(this.generalForm.expDate),
              polNo: this.polMaster.polNo,
              tranType: this.polMaster.tranType
            }
            const result = await this.$http.get(expandURI(apiUrl, expand))
            if (result.data) {
              this.error.endtDate = undefined
            }
            this.endtDateLoading = false
          } catch (err) {
            this.endtDateLoading = false
            const { data } = err.response
            if (data) {
              this.error.endtDate = data.messages[0].message
            }
          }
        } else {
          this.$toast.error('The request failed because it is trying to execute an invalid API url.')
        }
      }
    }
  },
  beforeMount() {
    this.doInit()
  },
  mounted() {},
  created() {
    // Local validator
    const valNotEqualUWYear = {
      getMessage: (field, args) => {
        return '10014 – ' + field + ' must equal Commencement Date Year. (10014)'
      },
      validate: (value, args) => {
        if (value) {
          if (args === void 0) args = []
          var comDateYr = args[0]
          if (comDateYr) {
            if (parseInt(value) !== parseInt(comDateYr)) return false
            else return true
          } else return true
        } else return true
      }
    }
    this.$validator.extend('valNotEqualUWYear', valNotEqualUWYear)

    const valEqualUWYear = {
      getMessage: (field, args) => {
        return '10015 – ' + field + ' must be different Commencement Date Year. (10015)'
      },
      validate: (value, args) => {
        if (value) {
          if (args === void 0) args = []
          var comDateYr = args[0]
          if (comDateYr) {
            if (parseInt(value) === parseInt(comDateYr)) return false
            else return true
          } else return true
        } else return true
      }
    }
    this.$validator.extend('valEqualUWYear', valEqualUWYear)

    const valUWYear = {
      getMessage: (field, args) => {
        return '10016 – This is more than 1 year earlier/later than current year. (10016)'
      },
      validate: (value, args) => {
        if (value) {
          if (args === void 0) args = []
          var todayYr = args[0]
          if (todayYr) {
            if (parseInt(value) !== parseInt(todayYr)) return false
            else return true
          } else return true
        } else return true
      }
    }
    this.$validator.extend('valUWYear', valUWYear)

    const isAvailTranDateRange = {
      getMessage: (field, args) => {
        return '00016 (Not found in Transaction Date Range file. (16))'
      },
      validate: (value, args) => {
        if (value) {
          if (args === void 0) args = []
          var fromDate = args[0]
          var toDate = args[1]
          if (fromDate === undefined) {
            return false
          } else if (toDate === undefined) {
            return false
          } else return true
        }
      }
    }
    this.$validator.extend('isAvailTranDateRange', isAvailTranDateRange)

    const valTranDateRange = {
      getMessage: (field, args) => {
        return '00017 – Date is not within permitted Date Range. Please check the Transaction Date Range parameters. (17))'
      },
      validate: (value, args) => {
        if (value) {
          if (args === void 0) args = []
          var fromDate = args[0]
          var toDate = args[1]
          if (isAfter(removeTime(fromDate), removeTime(value)) || isAfter(removeTime(value), removeTime(toDate))) {
            return false
          } else return true
        }
      }
    }
    this.$validator.extend('valTranDateRange', valTranDateRange)

    const valAcctPer = {
      tranDate: undefined,
      getMessage: (field, args) => {
        return '20140 – Account Period End Date ' + formatDisplayDate(valAcctPer.tranDate) + ' not found in Accounting Period file. (20140).'
      },
      validate: (value, args) => {
        if (value) {
          valAcctPer.tranDate = value
          if (args === void 0) args = []
          var acctPeriod = args[0]
          if (acctPeriod !== 'undefined') {
            if (acctPeriod === 'true') {
              return true
            } else return false
          } else return true
        }
      }
    }
    this.$validator.extend('valAcctPer', valAcctPer)

    // Local validator
    const valField = {
      getMessage: (field, args) => {
        if (args === void 0) args = []
        var errMsg = args[0]
        return errMsg
      },
      validate: (value, args) => {
        if (value) {
          if (args === void 0) args = []
          var errMsg = args[0]
          if (errMsg) {
            return false
          } else return true
        } else return true
      }
    }
    this.$validator.extend('valField', valField)
  },
  mixins: [MessageMixin]
}
</script>
